import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Notes = ({order = {}, prefix = ''}) => (
  <Panes
    entity={order}
    prefix={prefix}
    panes={[
      {
        title: 'Delivery Notes',
        fields: [
          <TextField
            name="notes"
            prefix={prefix}
            label="Notes"
            fieldProps={{multiline: true, rows: 4}}
          />,
        ]
      },
      {
        title: '',
        fields: []
      }
    ]}
    title=""/>
);

Notes.onSave = ({notes}) => ({notes});

export default Notes;
